<div class="cart-container">
  <h3>{{ T_SCOPE + '.cart-title' | translate }}</h3>
  <div class="cart-content">
    <div class="cart-item" *ngFor="let cartItem of cartItems">
      <div></div>
      <div class="cart-item-labels">
        <div class="cart-item-title">{{ cartItem.title$ | async }}</div>
        <div class="cart-item-subtitle">{{ cartItem.subtitle$ | async }}</div>
      </div>
      <div>
        <button
          mat-icon-button
          *ngIf="isSettingsComponent"
          (click)="onCartItemVisibilityChange(cartItem)"
        >
          <wlm-icon [icon]="cartItem.isVisible ? 'visibility' : 'visibility_off'"></wlm-icon>
        </button>
        <button mat-icon-button (click)="onRemoveCartItem(cartItem)">
          <wlm-icon [icon]="'delete'"></wlm-icon>
        </button>
      </div>
    </div>
  </div>
  <button
    *ngIf="!disableAddToDashboard"
    mat-raised-button
    color="primary"
    (click)="onAddToDashboard()"
    class="add-to-dashboard-btn"
    [disabled]="!cartItems.length || !widgetType"
  >
    {{ T_SCOPE + '.add-to-dashboard' | translate }}
  </button>
</div>
